import { useEffect, useRef, useState } from "react";
import Footer from '../../components/Footer';
import Swap from '../../components/Swap/Swap';

const Wallet = ({}) => {
    return (
        <>
            <Swap />
            <Footer />
        </>
    )
};

export default Wallet;